module.exports = __webpack_public_path__ + "static/img/li_5.c2caccf.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/li_5.jpeg
// module id = ILJa
// module chunks = 6